// Author lidongxu
// Date 2023-12-04 15:05:35

class SithMesStoolTransferTicketDetail {
    constructor({
                    id = null,
                    transferTicketNo = '',
                    projectCode = '',
                    wbs = '',
                    orderCode = '',
                    operationSeq = '',
                    operationDesc = '',
                    materialCode = '',
                    materialDescription = '',
                    operationQuantity = '',
                    projectMachineOne = '',
                    size = '',
                    pr = '',
                    forecastBeginTime = '',
                    forecastFinishTime = '',
                    relateDocument = '',
                    remark = ''
                }
                        = {}) {
        this.id = id;
        this.transferTicketNo = transferTicketNo;
        this.projectCode = projectCode;
        this.wbs = wbs;
        this.orderCode = orderCode;
        this.operationSeq = operationSeq;
        this.operationDesc = operationDesc;
        this.materialCode = materialCode;
        this.materialDescription = materialDescription;
        this.operationQuantity = operationQuantity;
        this.projectMachineOne = projectMachineOne;
        this.size = size;
        this.pr = pr;
        this.forecastBeginTime = forecastBeginTime;
        this.forecastFinishTime = forecastFinishTime;
        this.relateDocument = relateDocument;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesStoolTransferTicketDetail();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transferTicketNo',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.transferTicketNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbs',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.wbs',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCode',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.orderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationSeq',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.operationSeq',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationDesc',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.operationDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.materialDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationQuantity',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.operationQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectMachineOne',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.projectMachineOne',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'size',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.size',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'pr',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.pr',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastBeginTime',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.forecastBeginTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastFinishTime',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.forecastFinishTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'relateDocument',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.relateDocument',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.stool.sithMesStoolTransferTicketDetail.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    transferTicketNoFilter: '',
    transferTicketNoListFilter: [],
    projectCodeFilter: '',
    wbsFilter: '',
    orderCodeFilter: '',
    operationSeqFilter: '',
    operationDescFilter: '',
    materialCodeFilter: '',
    materialDescriptionFilter: '',
    operationQuantityFilter: '',
    projectMachineOneFilter: '',
    sizeFilter: '',
    prFilter: '',
    forecastbegintimeFilter: '',
    forecastFinishTimeFilter: '',
    relateDocumentFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'transferTicketNoFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.transferTicketNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.wbs',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationSeqFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.operationSeq',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationDescFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.operationDesc',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescriptionFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.materialDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationQuantityFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.operationQuantity',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachineOneFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.projectMachineOne',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sizeFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.size',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.pr',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTimeFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.forecastBeginTime',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.forecastFinishTime',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'relateDocumentFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.filter.relateDocument',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'transferTicketNo',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.transferTicketNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbs',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.wbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.orderCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationSeq',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.operationSeq',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationDesc',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.operationDesc',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.materialDescription',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationQuantity',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.operationQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachineOne',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.projectMachineOne',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'size',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.size',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pr',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.pr',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTime',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.forecastBeginTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTime',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.forecastFinishTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'relateDocument',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.relateDocument',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolTransferTicketDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesStoolTransferTicketDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
